import React, { useEffect, useState } from "react";
import {
  TextInput,
  Row,
  Column,
  FormGroup,
  RadioButtonGroup,
  RadioButton,
} from "carbon-components-react";
import useGet from "../../hooks/useGet";
import useAuth from "../../hooks/useAuth";
import GenericCombo from "../Combos/GenericCombo";
import ProvinceCombo from "../Combos/ProvinceCombo";
import DistrictCombo from "../Combos/DistrictCombo";
import http from "../../http-common";
import { toast } from "react-toastify";

const CompanyDetailsForm = ({
  disabled,
  reset,
  register,
  control,
  errors,
  setValue,
  candidature,
}) => {
  const { data: legalForms } = useGet("/lookup/legal-forms");
  const { data: yearsOfExperience } = useGet("/lookup/years-of-experience");
  const [isRegistered, setIsRegistered] = useState(
    candidature?.isRegisteredAndHasPermit,
  );
  const [hasLicense, setHasLicense] = useState(candidature?.hasLicense);
  const [hasCommercialRelation, setHasCommercialRelation] = useState(
    candidature?.hasRelationshipWithProgramEmployees,
  );
  const [districts, setDistricts] = useState([]);
  const { isCompetitor } = useAuth();

  const handleCompanyRegistration = (e) => {
    const value = e.target ? e.target.value : e; // Se for um evento, pega o value, se for um valor direto, usa o valor
    setIsRegistered(value === "true"); // Atualiza o estado com base no valor selecionado
  };

  const handleLicenseChange = (value) => {
    if (value === "true") {
      setHasLicense(true); // Marca que possui licença
    } else {
      setHasLicense(false); // Marca que não possui licença
    }
  };

  const handleRelationChange = (value) => {
    if (value === "true") {
      setHasCommercialRelation(true);
    } else {
      setHasCommercialRelation(false);
    }
  };

  const getDistricts = async (provinceId) => {
    if (provinceId) {
      try {
        const response = await http.get(
          "/lookup/provinces/" + provinceId + "/districts",
        );
        setDistricts(response.data);
      } catch (error) {
        toast.error(error?.response?.data.message);
      }
    } else {
      setDistricts([]);
    }
  };

  useEffect(() => {
    if (candidature) {
      setIsRegistered(candidature?.isRegisteredAndHasPermit);
      setHasLicense(candidature?.hasLicense);
      setHasCommercialRelation(
        candidature?.hasRelationshipWithProgramEmployees,
      );
      // Initialize districts if province is selected
      if (candidature?.provinceId) {
        getDistricts(candidature.provinceId);
      }
    }
  }, [candidature]);

  return (
    <FormGroup legendText="DADOS GERAIS DA EMPRESA" className="section-header">
      <fieldset className="bx--fieldset">
        <Row>
          <Column xml={12} sm={12} md={12} lg={12}>
            <p>
              Este é o formulário de candidatura ao{" "}
              <strong>PROJECTO FlowNegócios</strong> – Projecto Moz, que
              está a ser implementado pelo Ministério de Economia e Finanças,
              com apoio do Banco Mundial. Aceita responder a este formulário de
              forma voluntária e que a nossa equipa possa usar os dados
              recolhidos para fins relacionados com este projecto? Ao aceitar
              responder a este formulário não poderá deixar nenhuma questão em
              branco. Para qualquer documento que declarar que a sua empresa
              possui, será solicitado a apresentar formalmente. Muito Obrigado
              (a)!
            </p>
            <RadioButtonGroup
              name="dataUseConsent"
              disabled={disabled}
              valueSelected={candidature?.dataUseConsent?.toString()}
            >
              <RadioButton
                labelText="Sim"
                value="true"
                id="consent-y"
                {...register("dataUseConsent")}
              />
              <RadioButton
                labelText="Não"
                value="false"
                id="consent-n"
                {...register("dataUseConsent")}
              />
            </RadioButtonGroup>
            <p className="field-error">{errors.dataUseConsent?.message}</p>
          </Column>
        </Row>
        <Row>
          <Column xml={12} sm={4} md={4} lg={4} className="required">
            <TextInput
              labelText="1.1 Nome da Empresa"
              id="companyName"
              maxLength={255}
              disabled={disabled}
              {...register("companyName")}
            />
            <p className="field-error">{errors.companyName?.message}</p>
          </Column>
          <Column xml={12} sm={4} md={4} lg={4} className="required">
            <TextInput
              // placeholder="dd/mm/aaaa"
              labelText="1.2 Sede"
              id="companyHeadquarters"
              disabled={disabled}
              {...register("companyHeadquarters")}
            />
            <p className="field-error">{errors.companyHeadquarters?.message}</p>
          </Column>
          <Column xml={12} sm={4} md={4} lg={4} className="required">
            <TextInput
              labelText="1.3 NUIT"
              id="nuit"
              maxLength={9}
              disabled={disabled}
              {...register("nuit")}
            />
            <p className="field-error">{errors.nuit?.message}</p>
          </Column>
        </Row>
        <Row></Row>
        <Row>
          <Column xml={12} sm={4} md={4} lg={4} className="required">
            <TextInput
              id="startYearOfActivities"
              labelText="1.4 Ano de Início de Actividades"
              maxLength={13}
              disabled={disabled}
              {...register("startYearOfActivities")}
            />
            <p className="field-error">
              {errors.startYearOfActivities?.message}
            </p>
          </Column>
          <Column xml={12} sm={6} md={4} lg={4} className="required">
            <GenericCombo
              id="legalFormCode"
              name="legalFormCode"
              label="1.5 Forma Legal do Negócio"
              disabled={disabled}
              register={register}
              items={legalForms}
            />
            <p className="field-error">{errors.legalFormCode?.message}</p>
          </Column>

          <Column xml={12} sm={6} md={4} lg={4}>
            <TextInput
              id="otherLegalForm"
              labelText="Indique a outra forma legal"
              maxLength={50}
              disabled={disabled}
              {...register("otherLegalForm")}
            />
            <p className="field-error">{errors.otherLegalForm?.message}</p>
          </Column>
        </Row>
        <Row>
          <Column xml={12} sm={4} md={4} lg={4} className="required">
            <TextInput
              labelText="1.6 Pessoa de Contacto"
              id="contactPerson"
              maxLength={255}
              disabled={disabled}
              {...register("contactPerson")}
            />
            <p className="field-error">{errors.contactPerson?.message}</p>
          </Column>
          <Column xml={12} sm={4} md={4} lg={4} className="required">
            <ProvinceCombo
              id="provinceId"
              name="provinceId"
              label="Província"
              disabled={disabled}
              control={control}
              setDistricts={setDistricts}
            />
            <p className="field-error">{errors.provinceId?.message}</p>
          </Column>
          <Column xml={12} sm={4} md={4} lg={4} className="required">
            <DistrictCombo
              id="districtId"
              name="districtId"
              label="Distrito"
              disabled={disabled}
              control={control}
              items={districts}
            />
            <p className="field-error">{errors.districtId?.message}</p>
          </Column>
        </Row>
        <Row>
          <Column xml={12} sm={4} md={4} lg={4} className="required">
            <TextInput
              labelText="1.7 Cargo da Pessoa de Contacto"
              id="contactPersonRole"
              maxLength={255}
              disabled={disabled}
              {...register("contactPersonRole")}
            />
            <p className="field-error">{errors.contactPersonRole?.message}</p>
          </Column>
          <Column xml={12} sm={4} md={4} lg={4} className="required">
            <TextInput
              id="phoneNumber"
              labelText="1.8 Telemóvel (sem +258) "
              maxLength={9}
              disabled={disabled}
              {...register("phoneNumber")}
            />
            <p className="field-error">{errors.phoneNumber?.message}</p>
          </Column>
        </Row>
        <Row>
          <Column xml={12} sm={4} md={4} lg={4} className="required">
            <TextInput
              id="email"
              labelText="1.9 Email"
              maxLength={128}
              disabled={disabled}
              {...register("email")}
            />
            <p className="field-error">{errors.email?.message}</p>
          </Column>
          <Column sm={12} md={4} lg={4} className="">
            <TextInput
              id="website"
              name="website"
              labelText="1.10 Website"
              maxLength={20}
              disabled={disabled}
              {...register("website")}
            />
            <p className="field-error">{errors.website?.message}</p>
          </Column>
        </Row>
        <Row>
          <Column sm={12} md={6} lg={6} className="required">
            <GenericCombo
              id="yearsOfExperienceInSoftwareDevCode"
              name="yearsOfExperienceInSoftwareDevCode"
              label="3. Anos de Experiência em Desenvolvimento de Software "
              disabled={disabled}
              register={register}
              items={yearsOfExperience}
            />
            <p className="field-error">
              {errors.yearsOfExperienceInSoftwareDevCode?.message}
            </p>
          </Column>
          <Column sm={12} md={2} lg={2} className=""></Column>
          <Column sm={12} md={4} lg={4} className="required">
            <RadioButtonGroup
              name="hasExperienceInDigPlatformDev"
              disabled={disabled}
              legendText="3.1 A empresa já desenvolveu Projectos Moz?"
              valueSelected={candidature?.hasExperienceInDigPlatformDev?.toString()}
            >
              <RadioButton
                labelText="Sim"
                value="true"
                id="platform-yes"
                {...register("hasExperienceInDigPlatformDev")}
              />
              <RadioButton
                labelText="Não"
                value="false"
                id="platform-no"
                {...register("hasExperienceInDigPlatformDev")}
              />
            </RadioButtonGroup>
            <p className="field-error">
              {errors.hasExperienceInDigPlatformDev?.message}
            </p>
          </Column>
        </Row>
        <Row>
          <Column sm={12} md={12} lg={12} className="required">
            <RadioButtonGroup
              name="hasFinancialStatements"
              disabled={disabled}
              legendText="4. A sua empresa possui demonstrações financeiras auditadas nos últimos 3 anos?"
              valueSelected={candidature?.hasFinancialStatements?.toString()}
            >
              <RadioButton
                labelText="Sim"
                value="true"
                id="audit-yes"
                {...register("hasFinancialStatements")}
              />
              <RadioButton
                labelText="Não"
                value="false"
                id="audit-no"
                {...register("hasFinancialStatements")}
              />
            </RadioButtonGroup>
            <p className="field-error">
              {errors.hasFinancialStatements?.message}
            </p>
          </Column>
        </Row>
        <Row>
          <Column xsm={12} sm={6} md={6} lg={6} className="required">
            <TextInput
              id="applicationResponsibleName"
              labelText="5.1 Nome do Responsável da Candidatura"
              disabled={disabled}
              {...register("applicationResponsibleName")}
            />
            <p className="field-error">
              {errors.applicationResponsibleName?.message}
            </p>
          </Column>

          <Column xsm={12} sm={6} md={6} lg={6} className="required">
            <TextInput
              id="responsiblePosition"
              labelText="5.2. Posição que ocupa na empresa"
              disabled={disabled}
              {...register("responsiblePosition")}
            />
            <p className="field-error">{errors.responsiblePosition?.message}</p>
          </Column>
        </Row>
      </fieldset>
    </FormGroup>
  );
};

CompanyDetailsForm.defaultProps = {
  disabled: false,
};

export default CompanyDetailsForm;
